export enum SchedulePopoverOption {
  Other = 'other',
  Rebooter = 'rebooter',
  MultipleRebooters = 'multipleRebooters',
};
